
import type { SkillNode } from '../types';

export type FlatLeaf = {
  id: string;
  name: string;
  path: string;
  parentId: string | null;
  node: SkillNode;
};

export function flattenLeaves(root: SkillNode): FlatLeaf[] {
  const out: FlatLeaf[] = [];
  const walk = (n: SkillNode, trail: SkillNode[]) => {
    const nextTrail = [...trail, n];
    const kids = n.children ?? [];
    if (kids.length === 0) {
      const parent = trail.length ? trail[trail.length - 1] : null;
      out.push({
        id: n.id,
        name: n.name,
        path: nextTrail.map(x => x.name).join(' › '),
        parentId: parent ? parent.id : null,
        node: n,
      });
    } else {
      kids.forEach(c => walk(c, nextTrail));
    }
  };
  walk(root, []);
  return out;
}
